import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const PREFIX = 'dataGridFilters';

const classes = {
  container: `${PREFIX}-container`,
};

const StyledFilterDiv = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    height: '48px',
    maxHeight: '48px',
    display: 'flex',
    alignItems: 'center',
    gap: '24px',

    [`& .MuiFormControl-root`]: {
      flexDirection: 'row',
    },
  },
}));

type DataGridFiltersProps = {
  children: React.ReactNode;
};

const DataGridFilters = ({ children }: DataGridFiltersProps) => {
  return (
    <StyledFilterDiv className={classes.container}>{children}</StyledFilterDiv>
  );
};

export { DataGridFilters };
export type { DataGridFiltersProps };
